import { render, staticRenderFns } from "./exerciseResult.vue?vue&type=template&id=44d72e31"
import script from "./exerciseResult.vue?vue&type=script&lang=js"
export * from "./exerciseResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports